import React from "react";
import { Badge } from "@chakra-ui/react";
import { STATUS_LABELS, STATUS_SCHEME, DEFAULT_STATUS_SCHEME } from "./reservationsManageConstants";

/**
 * Renders the colored badge for a reservation status. Defaults to a neutral
 * scheme when the status is unknown so unfamiliar enum values do not crash the row.
 * @param {Object} props
 * @param {string} props.status - One of the 10 reservation status values
 * @returns {React.ReactElement}
 */
function ReservationStatusChip({ status }) {
  const scheme = STATUS_SCHEME[status] || DEFAULT_STATUS_SCHEME;
  const label = STATUS_LABELS[status] || status || "—";
  return (
    <Badge colorScheme={scheme} variant="subtle" borderRadius="6px" fontSize="0.7rem" px="8px" py="2px">
      {label}
    </Badge>
  );
}

export default ReservationStatusChip;
